import React from 'react';
import { FormControl, FormControlLabel, RadioGroup, Radio } from '@mui/material';

export const RadioElement = ({ item, value, onChange, readOnly }) => {
    const handleChange = (event) => {
        if (readOnly) return;
        const selectedId = event.target.value;
        const selectedOption = item?.properties?.options?.find((opt) => opt.id === selectedId);
        onChange(selectedOption ? { name: selectedOption.name, id: selectedOption.id } : null);
    };

    const options = (item?.properties?.options || []).filter((opt) => opt.name && opt.name.trim() !== '');

    return (
        <FormControl style={{ width: 'fit-content' }}>
            <RadioGroup value={value?.id || ''} onChange={handleChange}>
                {options.map((opt) => (
                    <FormControlLabel
                        key={opt.id}
                        value={opt.id}
                        control={<Radio color="primary" disabled={readOnly} style={{ padding: '4px 8px 4px 9px' }} />}
                        label={opt.name}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
};
